import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface UIState {
  sidebarCollapsed: boolean;
  aiPanelOpen: boolean;
  theme: Theme;
  toggleSidebar: () => void;
  toggleAIPanel: () => void;
  setAIPanel: (open: boolean) => void;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
}

export const useUIStore = create<UIState>()(
  persist<UIState>(
    (set) => ({
      sidebarCollapsed: false,
      aiPanelOpen: false,
      theme: 'light',
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      toggleAIPanel: () => set((s) => ({ aiPanelOpen: !s.aiPanelOpen })),
      setAIPanel: (open: boolean) => set({ aiPanelOpen: open }),
      toggleTheme: () => set((s) => {
        const next: Theme = s.theme === 'light' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', next);
        return { theme: next };
      }),
      setTheme: (theme: Theme) => {
        document.documentElement.setAttribute('data-theme', theme);
        set({ theme });
      },
    }),
    {
      name: 'nzt:ui',
    }
  )
);
